"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "FormEnclosedRadioButton", {
    enumerable: true,
    get: function() {
        return FormEnclosedRadioButton;
    }
});
const _style = /*#__PURE__*/ _interop_require_default(require("styled-jsx/style"));
const _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
const _Theme = require("../../../contexts/Theme");
const _FormGroupContext = require("../../../contexts/FormGroupContext");
const _Text = require("../../Text/Text");
const _Tooltip = require("../../Tooltip/Tooltip");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const OptionalTooltip = (param)=>{
    let { title, children } = param;
    if (title == null) {
        return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, children);
    }
    return /*#__PURE__*/ _react.default.createElement(_Tooltip.Tooltip, {
        title: title,
        placement: "bottom"
    }, children);
};
const FormEnclosedRadioButton = /*#__PURE__*/ (0, _react.forwardRef)((param, ref)=>{
    let { label, description, value: propsValue, tooltipText, rightButton, onChange, className, disabled = false, ...props } = param;
    const { hasError, id, hintId } = (0, _react.useContext)(_FormGroupContext.FormGroupContext);
    const { colors } = (0, _Theme.useTheme)();
    const [localValue, setLocalValue] = (0, _react.useState)(propsValue !== null && propsValue !== void 0 ? propsValue : false);
    const value = (0, _react.useMemo)(()=>propsValue !== null && propsValue !== void 0 ? propsValue : localValue, [
        propsValue,
        localValue
    ]);
    const inputId = (0, _react.useMemo)(()=>{
        var _props_id, _ref;
        return (_ref = (_props_id = props.id) !== null && _props_id !== void 0 ? _props_id : id) !== null && _ref !== void 0 ? _ref : props.name;
    }, [
        id,
        props.id,
        props.name
    ]);
    const handleChange = (e)=>{
        setLocalValue(e.target.checked);
        if (onChange != null) {
            onChange(e);
        }
    };
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("label", {
        htmlFor: inputId,
        className: _style.default.dynamic([
            [
                "196b8892c7198dd0",
                [
                    colors.grayscale[20],
                    colors.blue[60],
                    colors.grayscale[40],
                    colors.blue[60],
                    colors.grayscale[40],
                    description != null ? "1rem" : "0.5rem 1rem 0.5rem 0.5rem",
                    colors.transparent.black[10],
                    description != null ? "0.5rem" : "0.25rem",
                    colors.transparent.black[5],
                    colors.status.danger.primary,
                    colors.blue[10],
                    colors.blue[60],
                    colors.grayscale[3],
                    colors.grayscale[20],
                    colors.grayscale[10],
                    colors.grayscale[60],
                    colors.transparent.black[60]
                ]
            ]
        ]) + " " + ("label ".concat(value ? "label--active" : "", " ").concat(disabled ? "label--disabled" : "", " ").concat(hasError ? "label--error" : "", " ").concat(className !== null && className !== void 0 ? className : "").trim() || "")
    }, /*#__PURE__*/ _react.default.createElement("div", {
        className: _style.default.dynamic([
            [
                "196b8892c7198dd0",
                [
                    colors.grayscale[20],
                    colors.blue[60],
                    colors.grayscale[40],
                    colors.blue[60],
                    colors.grayscale[40],
                    description != null ? "1rem" : "0.5rem 1rem 0.5rem 0.5rem",
                    colors.transparent.black[10],
                    description != null ? "0.5rem" : "0.25rem",
                    colors.transparent.black[5],
                    colors.status.danger.primary,
                    colors.blue[10],
                    colors.blue[60],
                    colors.grayscale[3],
                    colors.grayscale[20],
                    colors.grayscale[10],
                    colors.grayscale[60],
                    colors.transparent.black[60]
                ]
            ]
        ]) + " " + "control"
    }, /*#__PURE__*/ _react.default.createElement(OptionalTooltip, {
        title: tooltipText
    }, /*#__PURE__*/ _react.default.createElement("input", {
        ...props,
        ref: ref,
        id: inputId,
        "aria-describedby": hintId,
        type: "radio",
        checked: value,
        disabled: disabled,
        onChange: handleChange,
        className: _style.default.dynamic([
            [
                "196b8892c7198dd0",
                [
                    colors.grayscale[20],
                    colors.blue[60],
                    colors.grayscale[40],
                    colors.blue[60],
                    colors.grayscale[40],
                    description != null ? "1rem" : "0.5rem 1rem 0.5rem 0.5rem",
                    colors.transparent.black[10],
                    description != null ? "0.5rem" : "0.25rem",
                    colors.transparent.black[5],
                    colors.status.danger.primary,
                    colors.blue[10],
                    colors.blue[60],
                    colors.grayscale[3],
                    colors.grayscale[20],
                    colors.grayscale[10],
                    colors.grayscale[60],
                    colors.transparent.black[60]
                ]
            ]
        ]) + " " + (props && props.className != null && props.className || "")
    }))), /*#__PURE__*/ _react.default.createElement("div", {
        className: _style.default.dynamic([
            [
                "196b8892c7198dd0",
                [
                    colors.grayscale[20],
                    colors.blue[60],
                    colors.grayscale[40],
                    colors.blue[60],
                    colors.grayscale[40],
                    description != null ? "1rem" : "0.5rem 1rem 0.5rem 0.5rem",
                    colors.transparent.black[10],
                    description != null ? "0.5rem" : "0.25rem",
                    colors.transparent.black[5],
                    colors.status.danger.primary,
                    colors.blue[10],
                    colors.blue[60],
                    colors.grayscale[3],
                    colors.grayscale[20],
                    colors.grayscale[10],
                    colors.grayscale[60],
                    colors.transparent.black[60]
                ]
            ]
        ]) + " " + "info"
    }, /*#__PURE__*/ _react.default.createElement(_Text.Text, {
        variant: description != null ? "heading" : "text",
        size: description != null ? "small" : "medium",
        className: "m-0"
    }, label), /*#__PURE__*/ _react.default.createElement(_Text.Text, {
        variant: "text",
        size: "extra-small",
        className: "description m-0"
    }, description)), rightButton), /*#__PURE__*/ _react.default.createElement(_style.default, {
        id: "196b8892c7198dd0",
        dynamic: [
            colors.grayscale[20],
            colors.blue[60],
            colors.grayscale[40],
            colors.blue[60],
            colors.grayscale[40],
            description != null ? "1rem" : "0.5rem 1rem 0.5rem 0.5rem",
            colors.transparent.black[10],
            description != null ? "0.5rem" : "0.25rem",
            colors.transparent.black[5],
            colors.status.danger.primary,
            colors.blue[10],
            colors.blue[60],
            colors.grayscale[3],
            colors.grayscale[20],
            colors.grayscale[10],
            colors.grayscale[60],
            colors.transparent.black[60]
        ]
    }, 'input[type="radio"].__jsx-style-dynamic-selector{width:16px;height:16px;background:#fff;border:1px solid '.concat(colors.grayscale[20], ';-webkit-border-radius:50%;-moz-border-radius:50%;border-radius:50%;-webkit-appearance:none;-moz-appearance:none;-ms-appearance:none;appearance:none;position:relative;margin:.25rem;cursor:pointer}input[type="radio"].__jsx-style-dynamic-selector:checked{border-color:').concat(colors.blue[60], '}input[type="radio"].__jsx-style-dynamic-selector:checked:disabled{border-color:').concat(colors.grayscale[40], '}input[type="radio"].__jsx-style-dynamic-selector:checked:before{content:"";position:absolute;-webkit-transform:translate(50%,50%);-moz-transform:translate(50%,50%);-ms-transform:translate(50%,50%);-o-transform:translate(50%,50%);transform:translate(50%,50%);top:0;left:0;width:50%;height:50%;-webkit-border-radius:50%;-moz-border-radius:50%;border-radius:50%;background-color:').concat(colors.blue[60], '}input[type="radio"].__jsx-style-dynamic-selector:checked:disabled:before{background-color:').concat(colors.grayscale[40], "}.label.__jsx-style-dynamic-selector{display:-webkit-inline-box;display:-webkit-inline-flex;display:-moz-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;white-space:nowrap;max-width:100%;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-border-radius:4px;-moz-border-radius:4px;border-radius:4px;padding:").concat(description != null ? "1rem" : "0.5rem 1rem 0.5rem 0.5rem", ";border:1px solid ").concat(colors.transparent.black[10], ";gap:").concat(description != null ? "0.5rem" : "0.25rem", "}.label.__jsx-style-dynamic-selector:not(.label--active):hover{cursor:pointer;background-color:").concat(colors.transparent.black[5], "}.label--error.__jsx-style-dynamic-selector,.label-error.__jsx-style-dynamic-selector input.__jsx-style-dynamic-selector{border-color:").concat(colors.status.danger.primary, "}.label--active.__jsx-style-dynamic-selector{background-color:").concat(colors.blue[10], ";border-color:").concat(colors.blue[60], "}.label--active.__jsx-style-dynamic-selector input.__jsx-style-dynamic-selector{cursor:default}.label--disabled.__jsx-style-dynamic-selector,.label--disabled.__jsx-style-dynamic-selector:not(.label--active):hover{cursor:auto;background-color:").concat(colors.grayscale[3], ";border-color:").concat(colors.grayscale[20], "}.label--disabled.label--active.__jsx-style-dynamic-selector{background-color:").concat(colors.grayscale[10], ";border-color:").concat(colors.grayscale[60], "}.label--disabled.__jsx-style-dynamic-selector input.__jsx-style-dynamic-selector{cursor:not-allowed}.control.__jsx-style-dynamic-selector{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex}.info.__jsx-style-dynamic-selector{-webkit-box-flex:1;-webkit-flex:1;-moz-box-flex:1;-ms-flex:1;flex:1;min-width:0;overflow:hidden;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.info.__jsx-style-dynamic-selector .description{color:").concat(colors.transparent.black[60], "}")));
});
FormEnclosedRadioButton.displayName = "FormEnclosedRadioButton";

//# sourceMappingURL=FormEnclosedRadioButton.js.map